import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./components/HomePage";
import GaryStory from "./pages/GaryStory";
import TheWorkHub from "./pages/TheWorkHub";
import WorkDetail from "./pages/WorkDetail";
import ListenPage from "./pages/ListenPage";
import GarysWorld from "./pages/GarysWorld";
import ConnectPage from "./pages/ConnectPage";
import PricingPage from "./pages/PricingPage";
import GiftPage from "./pages/GiftPage";
import GracefulPassages from "./pages/GracefulPassages";
import LoveYourLife from "./pages/LoveYourLife";
import ResonanceTouchstones from "./pages/ResonanceTouchstones";
import PortalsOfAwePage from "./pages/PortalsOfAwePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import WisdomKeepers from "./pages/WisdomKeepers";
import { AudioProvider } from "./context/AudioContext";
import { GlobalAudioPlayer } from "./components/GlobalAudioPlayer";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AudioProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/story" element={<GaryStory />} />
            <Route path="/work" element={<TheWorkHub />} />
            <Route path="/work/:key" element={<WorkDetail />} />
            <Route path="/listen" element={<ListenPage />} />
            <Route path="/world" element={<GarysWorld />} />
            <Route path="/connect" element={<ConnectPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/gift" element={<GiftPage />} />
            <Route path="/graceful-passages" element={<GracefulPassages />} />
            <Route path="/love-your-life" element={<LoveYourLife />} />
            <Route path="/resonance-touchstones" element={<ResonanceTouchstones />} />
            <Route path="/portals-of-awe" element={<PortalsOfAwePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/wisdom-keepers" element={<WisdomKeepers />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <GlobalAudioPlayer />
        </BrowserRouter>
      </AudioProvider>
    </div>
  );
}

export default App;
